import Vue from 'vue'
import Router from 'vue-router'
import Author from 'components/author'
import Login from 'components/login'
import LoginTwo from 'components/loginTwo'
import DataDisplay from 'components/dataDisplay'
import BusinessData from 'components/businessData'
import DishData from 'components/dishData'
import PayMentData from 'components/payMentData'
import OrderList from 'components/orderList'
import ShopSelect from 'components/shopSelect'
import UserSetting from 'components/userSetting'
import choose from 'components/choose'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Author  // 授权页
    },
    {
      path: '/login',
      component: Login   // 验证码登录页
    },
    {
      path: '/loginTwo',
      component: LoginTwo   // 普通登录页
    },
    {
      path: '/shopSelect',
      component: ShopSelect   // 商户列表选择页
    },
    {
      path: '/dataDisplay',
      component: DataDisplay,   // 数据展示页
      redirect: '/dataDisplay/businessData', // 默认路由
      children: [
        {
          path: 'businessData',
          component: BusinessData
        },
        {
          path: 'dishData',
          component: DishData
        },
        {
          path: 'userSetting',
          component: UserSetting
        }
      ]
    },
    {
      path: '/payMentData',
      component: PayMentData   // 支付数据页面
    },
    {
      path: '/orderList',
      component: OrderList   // 订单列表页面
    },
    // {
    //   path: '/userSetting',
    //   component: UserSetting   // 用户设置
    // },
    {
      path: '/choose',
      component: choose         // 筛选页面
    }
  ]
})
// router.beforeEach((to, from, next) => {
//   if (to.matched.length === 0) {
//     from.name ? next({ name: from.name }) : next('/')
//   } else {
//     next()
//   }
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js